// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalyticForm_wrapper__gUYZd","forms":"AnalyticForm_forms__FxfSH"};